module.exports = __webpack_public_path__ + "img/calendar.33e2a890.svg";